import { Controller } from "@hotwired/stimulus"
import intlTelInput from "intl-tel-input"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    console.log("Connected")
    this.iti = intlTelInput(this.inputTarget, {
      loadUtils: () => import("intl-tel-input/utils"),
      initialCountry: "auto",
      geoIpLookup: (success, failure) => {
        fetch("https://ipapi.co/json")
          .then((res) => res.json())
          .then((data) => success(data.country_code))
          .catch(() => failure());
      },
      containerClass: "w-full"
    })
  }
}
